import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub4_1/00a790dc582be53905f304a3d082ee54_water__c1_w280_h397.jpg'
import _imports_1 from '@/assets/thum_img/kp708b/sub4_1/5fd21a0f0f0639a690297ef6329cb2fc_water__c1_w280_h397.jpg'
import _imports_2 from '@/assets/thum_img/kp708b/sub4_1/54131fa75a7288dcb2c757f455317ec8_water__c1_w280_h397.jpg'
import _imports_3 from '@/assets/thum_img/kp708b/sub4_1/adf6257b1cbed48063e7e24a90e9e467_water__c1_w280_h397.jpg'


const _hoisted_1 = { class: "sub04_wrap" }

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'Talent_Items',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: `${_unref(USER_ROUTES).Product.Activity.Talent.Talent_e.Path}`
        }, {
          default: _withCtx(() => [
            _createElementVNode("figure", null, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    border: "0"
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bg" }, [
              _createElementVNode("span", null, "VIEW")
            ], -1))
          ]),
          _: 1
        }, 8, ["to"]),
        _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Activity_재능탐색_초등학생", -1))
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: `${_unref(USER_ROUTES).Product.Activity.Talent.Talent_m.Path}`
        }, {
          default: _withCtx(() => [
            _createElementVNode("figure", null, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    border: "0"
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bg" }, [
              _createElementVNode("span", null, "VIEW")
            ], -1))
          ]),
          _: 1
        }, 8, ["to"]),
        _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Activity_진로탐색_중학생", -1))
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: `${_unref(USER_ROUTES).Product.Activity.Talent.Talent_h.Path}`
        }, {
          default: _withCtx(() => [
            _createElementVNode("figure", null, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    border: "0"
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bg" }, [
              _createElementVNode("span", null, "VIEW")
            ], -1))
          ]),
          _: 1
        }, 8, ["to"]),
        _cache[8] || (_cache[8] = _createElementVNode("h1", null, "Activity_전공탐색_고등학생", -1))
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: `${_unref(USER_ROUTES).Product.Activity.Talent.Talent_u.Path}`
        }, {
          default: _withCtx(() => [
            _createElementVNode("figure", null, [
              _createVNode(_component_n_space, { justify: "center" }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createElementVNode("img", {
                    src: _imports_3,
                    border: "0"
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "bg" }, [
              _createElementVNode("span", null, "VIEW")
            ], -1))
          ]),
          _: 1
        }, 8, ["to"]),
        _cache[11] || (_cache[11] = _createElementVNode("h1", null, "Activity_직업탐색_대학생", -1))
      ])
    ])
  ]))
}
}

})